import { useEffect, useRef } from 'react';

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

// A textarea that grows to fit its content instead of scrolling inside a fixed
// height. Pass a `min-h-*` class for the starting/minimum height; the inline
// height set here only ever grows past that minimum.
export function AutoGrowTextarea({ value, className, ...rest }: Props): JSX.Element {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  return (
    <textarea
      ref={ref}
      value={value}
      className={`resize-none overflow-hidden ${className ?? ''}`}
      {...rest}
    />
  );
}
